import moment from 'moment'

let now = new Date(Date.now())
let date = {
    currDay() {
        return now;
    },
    currLastMonth() {
        return new Date(new Date().setDate(new Date().getDate() - 30));
    },
    curDateTime() {
        var date = new Date();
        var year = date.getFullYear();        //年 ,从 Date 对象以四位数字返回年份
        var month = date.getMonth() + 1;      //月 ,从 Date 对象返回月份 (0 ~ 11) ,date.getMonth()比实际月份少 1 个月
        var day = date.getDate();             //日 ,从 Date 对象返回一个月中的某一天 (1 ~ 31)
        var hours = date.getHours();          //小时 ,返回 Date 对象的小时 (0 ~ 23)
        var minutes = date.getMinutes();      //分钟 ,返回 Date 对象的分钟 (0 ~ 59)
        var seconds = date.getSeconds();      //秒 ,返回 Date 对象的秒数 (0 ~ 59)   

        //修改月份格式
        if (month >= 1 && month <= 9) {
            month = "0" + month;
        }

        //修改日期格式
        if (day >= 0 && day <= 9) {
            day = "0" + day;
        }

        //修改小时格式
        if (hours >= 0 && hours <= 9) {
            hours = "0" + hours;
        }

        //修改分钟格式
        if (minutes >= 0 && minutes <= 9) {
            minutes = "0" + minutes;
        }

        //修改秒格式
        if (seconds >= 0 && seconds <= 9) {
            seconds = "0" + seconds;
        }

        //获取当前系统时间  格式(yyyy-mm-dd hh:mm:ss)
        var currentFormatDate = year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
        return currentFormatDate
    },
    /**
     * 将时间戳或者中国标准时间处理成 2018-05-01 00:00:00  这种格式
     * @param {时间戳或者中国标准时间} timestamp 
     * @param {一状态 } state   ture要时分秒  false不要时分秒 
     */
    timestampToTime(timestamp, state = false) {
        var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-';
        var M = ((date.getMonth() + 1) > 9 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1)) + '-';
        var D = (date.getDate() > 9 ? date.getDate() : '0' + date.getDate());
        var h = (date.getHours() > 9 ? date.getHours() : '0' + date.getHours()) + ':';
        var m = (date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes()) + ':';
        var s = date.getSeconds() > 9 ? date.getSeconds() : '0' + date.getSeconds();
        return state ? Y + M + D + ' ' + h + m + s : Y + M + D;
    },
    /**
     * 根据当前时间加上时间返回新的时间
     * @param {加上多少秒} second
     * @param {时间戳或者中国标准时间} timestamp 不穿默认为当前时间
     * @returns {string} 2018-05-01 00:00:00
     */
    addHours(second, timestamp = '') {
        if (timestamp === '') {
            timestamp = new Date().getTime();
        }
        var date = new Date(timestamp);
        date.setTime(date.getTime() + second * 1000);
        var M = ((date.getMonth() + 1) > 9 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1)) + '-';
        var D = (date.getDate() > 9 ? date.getDate() : '0' + date.getDate());
        var h = (date.getHours() > 9 ? date.getHours() : '0' + date.getHours()) + ':';
        var m = (date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes()) + ':';
        var s = date.getSeconds() > 9 ? date.getSeconds() : '0' + date.getSeconds();
        return M + D + ' ' + h + m + s;
    },
    /**
     * 设置日期范围
     * @param {string} type - 日期范围类型，'today'、'yesterday' 或 'last7'
     * @returns {void}
    */
    getDateRange(type) {
        const today = moment().startOf('day')
        let dateRange = [] // 假设 dateRange 是一个响应式对象
        const yesterday = moment().subtract(1, 'day').startOf('day')
        switch (type) {
          case 'today':
            dateRange = [today.format('YYYY-MM-DD') + ' 00:00:00', today.format('YYYY-MM-DD') + ' 23:59:59']
            break
          case 'yesterday':
            dateRange = [yesterday.format('YYYY-MM-DD') + ' 00:00:00', yesterday.format('YYYY-MM-DD') + ' 23:59:59']
            break
          case 'last7':
            dateRange = [
              moment().subtract(6, 'days').startOf('day').format('YYYY-MM-DD') + ' 00:00:00',
              today.format('YYYY-MM-DD') + ' 23:59:59'
            ]
            break
        }
        return dateRange
      },
      /**
       * 计算与目标时间的差值
       * @param {number} targetHour - 目标时间的小时部分，默认为 21
       * @param {number} targetMinute - 目标时间的分钟部分，默认为 30
       * @param {number} targetSecond - 目标时间的秒部分，默认为 0
       * @returns {Object} 包含目标时间对象、毫秒差值、秒差值和是否是明天的标志
       * @description 该函数计算当前时间与指定目标时间之间的差值。如果当前时间晚于目标时间，则认为目标时间是明天的同一时刻。
       * @example
       * const diff = getTimeDiff(21, 30, 0);
       * console.log(diff.targetTime); // 输出目标时间对象
       * console.log(diff.diffMilliseconds); // 输出毫秒差值
       * console.log(diff.diffSeconds); // 输出秒差值
       * console.log(diff.isTomorrow); // 输出是否是明天的标志
       * @returns {Object} 包含目标时间对象、毫秒差值、秒差值和是否是明天的标志
       * 
      */
      getTimeDiff(targetHour = 21, targetMinute = 30, targetSecond = 0) {
        const now = new Date();
      
        // 设定目标时间（初步设为今天）
        const targetTime = new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate(),
          targetHour,
          targetMinute,
          targetSecond
        );
      
        // 如果当前时间晚于目标时间，说明是明天的目标时间
        if (now > targetTime) {
          targetTime.setDate(targetTime.getDate() + 1);
        }
      
        const diffMilliseconds = targetTime - now;
        const diffSeconds = Math.floor(diffMilliseconds / 1000);
      
        // targetTime 转为 年月日 时间
        const formattedTargetTime = moment(targetTime).format('MM-DD HH:mm:ss');
        return {
          formattedTargetTime,        // 最终的目标时间对象
          diffMilliseconds,  // 毫秒差值
          diffSeconds,       // 秒差值
          isTomorrow: now > targetTime // 是否是明天的时间
        };
      }
}

export default date